<template>
  <div class="map-box">
    <div class="l-menu">
      <a :href="this.btn_0" target="_blank">
        <div class="img-btn" :style="{ backgroundImage: `url(${button0})` }"></div>
      </a>
      <a :href="this.btn_1" target="_blank">
        <div class="img-btn" :style="{ backgroundImage: `url(${button1})` }"></div>
      </a>
      <a :href="this.btn_2" target="_blank">
        <div class="img-btn" :style="{ backgroundImage: `url(${button2})` }"></div>
      </a>
      <a :href="this.btn_3" target="_blank">
        <div class="img-btn" :style="{ backgroundImage: `url(${button3})` }"></div>
      </a>
      <a :href="this.btn_0" target="_blank" class="btn_word_style" :style="{ backgroundImage: `url(${Img_Word})` }"></a>
      <!-- <div class="btn_load_style" :style="{ backgroundImage: `url(${load_text})` }"></div> -->
      <a-popover
        title="扫码进入手机版客户端"
        trigger="hover"
        :visible="hovered"
        @visibleChange="handleHoverChange"
      >
        <div slot="content">
          <div style="width:200px;height:200px;background-size:100%;" :style="{ backgroundImage: `url(${mx_img})` }"></div>
        </div>
        <a-popover
          title="扫码进入手机版客户端"
          trigger="click"
          :visible="clicked"
          @visibleChange="handleClickChange"
        >
          <div slot="content">
            <div >
              <div style="width:200px;height:200px;background-size:100%;" :style="{ backgroundImage: `url(${mx_img})` }"></div>
            </div>
            <a @click="hide">关闭</a>
          </div>
          <a class="btn_abs_style" :style="{ backgroundImage: `url(${btn_Bg})` }"></a>
        </a-popover>
      </a-popover>
    </div>
    <div class="r-map">
      <img :src="map" usemap="#FPMap0" />
      <map name="FPMap0" >
        <router-link target="_blank" :to="{ path: '/county', query:{ orgId: 371086000000 } }">
          <area u="gaoqu" shape="rect" coords="302, 74, 373, 103" @click="mapClick({ orgId: 371086000000 })" href="#" />
        </router-link>
        <router-link target="_blank" :to="{ path: '/county', query: { orgId: 371002000000 } }">
          <area u="huancui" shape="rect" coords="384, 74, 448, 99" @click="mapClick({ orgId: 371002000000 })" href="#" />
        </router-link>
        <router-link target="_blank" :to="{ path: '/county', query: { orgId: 371087000000 } }">
          <area u="jingqu" shape="rect" coords="461, 78, 526, 105" @click="mapClick({ orgId: 371087000000 })" href="#" />
        </router-link>
        <router-link target="_blank" :to="{ path: '/county', query: { orgId: 371081000000 } }">
          <area u="wendeng" shape="rect" coords="281, 125, 348, 157" @click="mapClick({ orgId: 371081000000 })" href="#" />
        </router-link>
        <router-link target="_blank" :to="{ path: '/county', query: { orgId: 371085000000 } }">
          <area u="lingang" shape="rect" coords="368, 124, 435, 151" @click="mapClick({ orgId: 371085000000 })" href="#"/>
        </router-link>
        <router-link target="_blank" :to="{ path: '/county', query: { orgId: 371082000000 } }">
          <area u="rongcheng" shape="rect" coords="503, 126, 568, 150" @click="mapClick({ orgId: 371082000000 })" href="#"/>
        </router-link>
        <router-link target="_blank" :to="{ path: '/county', query: { orgId: 371088000000 } }">
          <area u="nanhai" shape="rect" coords="359, 182, 421, 211" @click="mapClick({ orgId: 371088000000 })" href="#"/>
        </router-link>
        <router-link target="_blank" :to="{ path: '/county', query: { orgId: 371083000000 } }">
          <area u="rushan" shape="rect" coords="190, 182, 259, 211" @click="mapClick({ orgId: 371083000000 })" href="#"/>
        </router-link>
      </map>
    </div>
  </div>
</template>
<script>
import button0 from '@/assets/contextBox/button0.jpg'
import button1 from '@/assets/contextBox/button1.jpg'
import button2 from '@/assets/contextBox/button2.jpg'
import button3 from '@/assets/contextBox/button3.jpg'
// eslint-disable-next-line camelcase
import btn_Bg from '@/assets/contextBox/ms_btn_bg.jpg'
// eslint-disable-next-line camelcase
import Img_Word from '@/assets/contextBox/img_word.jpg'
// eslint-disable-next-line camelcase
import load_text from '@/assets/contextBox/load_text.jpg'
// eslint-disable-next-line camelcase
import mx_img from '@/assets/contextBox/mx_img.jpg'
import map from '@/assets/contextBox/map.jpg'
import { ExternalList } from '@/api/main/ExternalListManager'
import { SysOrgCounty } from '@/api/main/SysOrgcountyManager'
export default {
  data() {
    return {
      button0: button0,
      button1: button1,
      button2: button2,
      button3: button3,
      btn_Bg: btn_Bg,
      Img_Word: Img_Word,
      load_text: load_text,
      mx_img: mx_img,
      map: map,
      btn_0: '',
      btn_1: '',
      btn_2: '',
      btn_3: '',
      /** 悬浮气泡 */
      clicked: false,
      hovered: false,
      /** 子区市的数据 */
      getChildData: []
    }
  },
  created() {
    this.ExternalListMethod()
    this.getChildCreate()
  },
  methods: {
    ExternalListMethod() {
      ExternalList().then(res => {
        this.ExternalData = res.data
        this.ExternalData.forEach(item => {
          if (item.code === 'people_platform') {
            this.btn_0 = item.value
          }
          if (item.code === 'property_right_trade') {
            this.btn_1 = item.value
          }
          if (item.code === 'LAZADA') {
            this.btn_2 = item.value
          }
          if (item.code === 'work_plantform') {
            this.btn_3 = item.value
          }
        })
      })
    },
    btn_0_Click() {
      var ret = this.ExternalData.filter(item => item.code === 'people_platform')
      this.btn_0 = ret.value
    },
    btn_1_Click() {
         var ret = this.ExternalData.filter(item => item.code === 'property_right_trade')
      this.btn_1 = ret.value
    },
    btn_2_Click() {
       var ret = this.ExternalData.filter(item => item.code === 'LAZADA')
      this.btn_2 = ret.value
    },
    btn_3_Click() {
       var ret = this.ExternalData.filter(item => item.code === 'work_plantform')
      this.btn_3 = ret.value
    },
    hide() {
      this.clicked = false;
      this.hovered = false;
    },
    handleHoverChange(visible) {
      this.clicked = false;
      this.hovered = visible;
    },
    handleClickChange(visible) {
      this.clicked = visible;
      this.hovered = false;
    },
    /** 查区市的orgId */
    getChildCreate() {
      SysOrgCounty().then(res => {
        this.getChildData = res.data
      })
    },
    mapClick(val) {
         const map = this.$router.resolve({ path: '/county', query: val })
         window.open(map.href, '_blank')
    }
  }
}
</script>
<style lang="less" scoped>
.map-box {
  width: 100%;
  display: flex;
  flex-flow: row nowrap;
  height: 369px;
  overflow: hidden;
  .l-menu {
    width: 278px;
    position: relative;
    .img-btn {
      width: 278px;
      height: 92.25px;
      background-size: cover;
      cursor: pointer;
    }
  }
  .btn_word_style{
    width: 170px;
    height: 35px;
    left: 75px;
    top: 30px;
    position:absolute;
    z-index: 999;
  }
  .btn_abs_style{
    width: 55px;
    height: 55px;
    right: 0;
    top: 0;
    position:absolute;
    background-size: 100%;
    }
    .btn_load_style{
    width: 80px;
    height: 20px;
    right: 50px;
    top: 10px;
    background-size: 100%;
    z-index: 888;
    position:absolute;
    }
    .mx_img {
        width: 200px;
        height: 200px;
        background-size: 100%;
    }
  .r-map {
    flex: 1;
    height: 369px;
  }
}
</style>
